import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCoupons = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 82,
	height: 72,
	viewBox: "0 0 82 72",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M78.215 42.711C79.352 40.555 80 38.105 80 35.5C80 28.879 75.84 23.242 70 21.023C70 21.015 70 21.007 70 21C70 9.402 60.598 0 49 0C39.215 0 31.02 6.699 28.687 15.758C27.211 15.273 25.637 15 24 15C16.309 15 9.977 20.793 9.109 28.254C3.906 29.352 0 33.969 0 39.5C0 45.852 5.148 51 11.5 51C11.676 51 11.852 50.988 12.027 50.977C12.023 51.152 12 51.324 12 51.5C12 62.82 21.18 72 32.5 72C38.937 72 44.676 69.027 48.434 64.387C50.613 66.609 53.641 68 57 68C61.648 68 65.676 65.352 67.664 61.48C68.719 61.816 69.836 62 71 62C77.074 62 82 57.074 82 51C82 47.687 80.531 44.727 78.215 42.711Z",
			fill: "#DEF0E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.405 65H13.5C13.224 65 13 64.776 13 64.5C13 64.224 13.224 64 13.5 64H23.405C23.681 64 23.905 64.224 23.905 64.5C23.905 64.776 23.682 65 23.405 65Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5 65H25.5C25.224 65 25 64.776 25 64.5C25 64.224 25.224 64 25.5 64H26.5C26.776 64 27 64.224 27 64.5C27 64.776 26.777 65 26.5 65Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.491 67H22.5C22.224 67 22 66.776 22 66.5C22 66.224 22.224 66 22.5 66H31.491C31.767 66 31.991 66.224 31.991 66.5C31.991 66.776 31.767 67 31.491 67Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5 67H19.5C19.224 67 19 66.776 19 66.5C19 66.224 19.224 66 19.5 66H20.5C20.776 66 21 66.224 21 66.5C21 66.776 20.777 67 20.5 67Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5 67H15.5C15.224 67 15 66.776 15 66.5C15 66.224 15.224 66 15.5 66H17.5C17.776 66 18 66.224 18 66.5C18 66.776 17.777 67 17.5 67Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5 69H21.5C21.224 69 21 68.776 21 68.5C21 68.224 21.224 68 21.5 68H23.5C23.776 68 24 68.224 24 68.5C24 68.776 23.776 69 23.5 69Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5 60C26.323 60 25.677 60 25.5 60C25.224 60 25 60.224 25 60.5C25 60.776 25.224 61 25.5 61C25.677 61 26.323 61 26.5 61C26.776 61 27 60.776 27 60.5C27 60.224 26.776 60 26.5 60Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5 62C26.323 62 21.677 62 21.5 62C21.224 62 21 62.224 21 62.5C21 62.776 21.224 63 21.5 63C21.677 63 26.323 63 26.5 63C26.776 63 27 62.776 27 62.5C27 62.224 26.776 62 26.5 62Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.5 64C31.323 64 28.677 64 28.5 64C28.224 64 28 64.224 28 64.5C28 64.776 28.224 65 28.5 65C28.677 65 31.323 65 31.5 65C31.776 65 32 64.776 32 64.5C32 64.224 31.776 64 31.5 64Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.5 10H53.5C53.224 10 53 9.776 53 9.5C53 9.224 53.224 9 53.5 9H63.5C63.776 9 64 9.224 64 9.5C64 9.776 63.776 10 63.5 10Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.5 10H65.5C65.224 10 65 9.776 65 9.5C65 9.224 65.224 9 65.5 9H67.5C67.776 9 68 9.224 68 9.5C68 9.776 67.776 10 67.5 10Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.5 12H62.5C62.224 12 62 11.776 62 11.5C62 11.224 62.224 11 62.5 11H72.5C72.776 11 73 11.224 73 11.5C73 11.776 72.777 12 72.5 12Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.5 12H59.5C59.224 12 59 11.776 59 11.5C59 11.224 59.224 11 59.5 11H60.5C60.776 11 61 11.224 61 11.5C61 11.776 60.776 12 60.5 12Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.375 12H55.5C55.224 12 55 11.776 55 11.5C55 11.224 55.224 11 55.5 11H57.375C57.651 11 57.875 11.224 57.875 11.5C57.875 11.776 57.651 12 57.375 12Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.5 8H61.5C61.224 8 61 7.776 61 7.5C61 7.224 61.224 7 61.5 7H66.5C66.776 7 67 7.224 67 7.5C67 7.776 66.777 8 66.5 8Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.5 14H61.5C61.224 14 61 13.776 61 13.5C61 13.224 61.224 13 61.5 13H63.5C63.776 13 64 13.224 64 13.5C64 13.776 63.776 14 63.5 14Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.75 24.5C25.75 24.5 29.39 24.5 31.875 24.5C34.36 24.5 36.375 22.485 36.375 20C36.375 17.667 34.593 15.771 32.32 15.545C32.342 15.364 32.375 15.187 32.375 15C32.375 12.515 30.36 10.5 27.875 10.5C26.437 10.5 25.172 11.186 24.348 12.236C24.208 9.6 22.046 7.5 19.375 7.5C16.614 7.5 14.375 9.739 14.375 12.5C14.375 12.946 14.452 13.37 14.562 13.782C13.92 13.005 12.962 12.5 11.875 12.5C10.094 12.5 8.641 13.835 8.42 15.555C8.239 15.533 8.062 15.5 7.875 15.5C5.39 15.5 3.375 17.515 3.375 20C3.375 22.485 5.39 24.5 7.875 24.5C10.36 24.5 17.375 24.5 17.375 24.5H22.75V25H25.75V24.5Z",
			fill: "#FDFCEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.375 7C16.342 7 13.875 9.467 13.875 12.5C13.875 12.516 13.875 12.531 13.875 12.547C13.273 12.193 12.585 12 11.875 12C10.044 12 8.464 13.261 8.017 15.005C7.97 15.002 7.923 15 7.875 15C5.118 15 2.875 17.243 2.875 20C2.875 22.757 5.118 25 7.875 25H22.75C23.026 25 23.25 24.776 23.25 24.5C23.25 24.224 23.026 24 22.75 24H7.875C5.669 24 3.875 22.206 3.875 20C3.875 17.794 5.669 16 7.875 16C7.992 16 8.105 16.017 8.218 16.032L8.359 16.051C8.38 16.054 8.4 16.055 8.421 16.055C8.667 16.055 8.883 15.87 8.916 15.618C9.107 14.125 10.379 13 11.875 13C12.76 13 13.598 13.401 14.176 14.1C14.274 14.218 14.417 14.282 14.562 14.282C14.64 14.282 14.718 14.264 14.79 14.226C14.999 14.119 15.104 13.88 15.044 13.653C14.928 13.217 14.874 12.851 14.874 12.5C14.874 10.019 16.893 8 19.374 8C21.755 8 23.721 9.872 23.848 12.263C23.859 12.471 23.998 12.65 24.197 12.713C24.247 12.729 24.298 12.737 24.349 12.737C24.499 12.737 24.645 12.668 24.741 12.545C25.513 11.563 26.654 11 27.875 11C30.081 11 31.875 12.794 31.875 15C31.875 15.117 31.858 15.23 31.843 15.343L31.824 15.484C31.808 15.618 31.846 15.752 31.93 15.857C32.014 15.962 32.137 16.029 32.27 16.042C34.325 16.247 35.874 17.948 35.874 20C35.874 22.206 34.08 24 31.874 24H25.75C25.474 24 25.25 24.224 25.25 24.5C25.25 24.776 25.474 25 25.75 25H31.875C34.632 25 36.875 22.757 36.875 20C36.875 17.603 35.186 15.587 32.872 15.123C32.874 15.082 32.875 15.041 32.875 15C32.875 12.243 30.632 10 27.875 10C26.699 10 25.582 10.416 24.692 11.164C24.094 8.76 21.93 7 19.375 7Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.875 14C16.472 14 15.266 14.999 14.962 16.341C14.595 16.119 14.176 16 13.75 16C12.548 16 11.552 16.897 11.397 18.068C11.194 18.022 11.001 18 10.812 18C9.28301 18 8.00101 19.2 7.89401 20.732C7.88501 20.87 7.98901 20.99 8.12601 21C8.13201 21 8.13801 21 8.14401 21C8.27401 21 8.38401 20.899 8.39301 20.768C8.48201 19.497 9.54401 18.5 10.812 18.5C11.041 18.5 11.282 18.542 11.55 18.627C11.572 18.634 11.595 18.637 11.617 18.637C11.672 18.637 11.727 18.617 11.773 18.583C11.837 18.536 11.875 18.454 11.875 18.374C11.875 17.34 12.716 16.499 13.75 16.499C14.197 16.499 14.635 16.667 14.981 16.972C15.028 17.013 15.087 17.035 15.146 17.035C15.178 17.035 15.209 17.029 15.239 17.016C15.327 16.981 15.387 16.899 15.394 16.804C15.496 15.512 16.585 14.499 17.873 14.499C18.081 14.499 18.298 14.533 18.555 14.606C18.578 14.613 18.602 14.616 18.625 14.616C18.734 14.616 18.832 14.543 18.864 14.434C18.902 14.301 18.825 14.163 18.692 14.125C18.392 14.04 18.131 14 17.875 14Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.758 15.5C30.432 15.5 29.25 16.397 28.884 17.682C28.846 17.815 28.923 17.953 29.056 17.991C29.08 17.997 29.103 18 29.125 18C29.234 18 29.334 17.928 29.365 17.818C29.67 16.748 30.654 16 31.758 16C31.875 16 31.988 16.014 32.1 16.029C32.112 16.031 32.123 16.032 32.135 16.032C32.256 16.032 32.364 15.94 32.381 15.815C32.4 15.678 32.304 15.552 32.167 15.534C32.033 15.516 31.897 15.5 31.758 15.5Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.833 55.3C15.657 55.3 14.7 54.343 14.7 53.166V42.648C16.961 42.309 18.7 40.354 18.7 38C18.7 35.646 16.961 33.691 14.7 33.352V23.833C14.7 22.656 15.657 21.699 16.833 21.699H69.167C70.343 21.699 71.3 22.656 71.3 23.833V33.352C69.039 33.691 67.3 35.646 67.3 38C67.3 40.354 69.039 42.309 71.3 42.648V53.167C71.3 54.344 70.343 55.301 69.167 55.301H16.833V55.3Z",
			fill: "#BDE0CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.167 22.4C69.957 22.4 70.6 23.043 70.6 23.834V32.785C68.299 33.403 66.6 35.507 66.6 38.001C66.6 40.495 68.299 42.599 70.6 43.217V53.168C70.6 53.959 69.957 54.602 69.167 54.602H16.833C16.043 54.602 15.4 53.959 15.4 53.168V43.217C17.701 42.599 19.4 40.495 19.4 38.001C19.4 35.507 17.701 33.403 15.4 32.785V23.834C15.4 23.043 16.043 22.4 16.833 22.4H69.167ZM69.167 21H16.833C15.269 21 14 22.269 14 23.833V34C16.209 34 18 35.791 18 38C18 40.209 16.209 42 14 42V53.167C14 54.731 15.269 56 16.833 56H69.166C70.731 56 72 54.731 72 53.167V42C69.791 42 68 40.209 68 38C68 35.791 69.791 34 72 34V23.833C72 22.269 70.731 21 69.167 21Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63 29C63.5523 29 64 28.5523 64 28C64 27.4477 63.5523 27 63 27C62.4477 27 62 27.4477 62 28C62 28.5523 62.4477 29 63 29Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63 25C63.5523 25 64 24.5523 64 24C64 23.4477 63.5523 23 63 23C62.4477 23 62 23.4477 62 24C62 24.5523 62.4477 25 63 25Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63 33C63.5523 33 64 32.5523 64 32C64 31.4477 63.5523 31 63 31C62.4477 31 62 31.4477 62 32C62 32.5523 62.4477 33 63 33Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63 37C63.5523 37 64 36.5523 64 36C64 35.4477 63.5523 35 63 35C62.4477 35 62 35.4477 62 36C62 36.5523 62.4477 37 63 37Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63 41C63.5523 41 64 40.5523 64 40C64 39.4477 63.5523 39 63 39C62.4477 39 62 39.4477 62 40C62 40.5523 62.4477 41 63 41Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63 45C63.5523 45 64 44.5523 64 44C64 43.4477 63.5523 43 63 43C62.4477 43 62 43.4477 62 44C62 44.5523 62.4477 45 63 45Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63 49C63.5523 49 64 48.5523 64 48C64 47.4477 63.5523 47 63 47C62.4477 47 62 47.4477 62 48C62 48.5523 62.4477 49 63 49Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63 53C63.5523 53 64 52.5523 64 52C64 51.4477 63.5523 51 63 51C62.4477 51 62 51.4477 62 52C62 52.5523 62.4477 53 63 53Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.521 25.75H45.833C45.695 25.75 45.583 25.638 45.583 25.5C45.583 25.362 45.695 25.25 45.833 25.25H59.521C59.659 25.25 59.771 25.362 59.771 25.5C59.771 25.638 59.658 25.75 59.521 25.75Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.917 25.75H31.667C31.529 25.75 31.417 25.638 31.417 25.5C31.417 25.362 31.529 25.25 31.667 25.25H41.917C42.055 25.25 42.167 25.362 42.167 25.5C42.167 25.638 42.055 25.75 41.917 25.75Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.5 25.75H18.5C18.362 25.75 18.25 25.638 18.25 25.5C18.25 25.362 18.362 25.25 18.5 25.25H28.5C28.638 25.25 28.75 25.362 28.75 25.5C28.75 25.638 28.638 25.75 28.5 25.75Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5 32C18.362 32 18.25 31.888 18.25 31.75V25.516C18.25 25.378 18.362 25.266 18.5 25.266C18.638 25.266 18.75 25.378 18.75 25.516V31.75C18.75 31.888 18.638 32 18.5 32Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.5 31.75C59.362 31.75 59.25 31.638 59.25 31.5V25.5C59.25 25.362 59.362 25.25 59.5 25.25C59.638 25.25 59.75 25.362 59.75 25.5V31.5C59.75 31.638 59.638 31.75 59.5 31.75Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.502 51.732C59.364 51.732 59.252 51.62 59.252 51.482V35.521C59.252 35.383 59.364 35.271 59.502 35.271C59.64 35.271 59.752 35.383 59.752 35.521V51.483C59.752 51.621 59.64 51.732 59.502 51.732Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5 51.792C18.362 51.792 18.25 51.68 18.25 51.542V45.308C18.25 45.17 18.362 45.058 18.5 45.058C18.638 45.058 18.75 45.17 18.75 45.308V51.542C18.75 51.68 18.638 51.792 18.5 51.792Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.5 51.75H53.667C53.529 51.75 53.417 51.638 53.417 51.5C53.417 51.362 53.529 51.25 53.667 51.25H59.5C59.638 51.25 59.75 51.362 59.75 51.5C59.75 51.638 59.638 51.75 59.5 51.75Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.417 51.75H42.667C42.529 51.75 42.417 51.638 42.417 51.5C42.417 51.362 42.529 51.25 42.667 51.25H50.417C50.555 51.25 50.667 51.362 50.667 51.5C50.667 51.638 50.555 51.75 50.417 51.75Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.75 51.75H18.5C18.362 51.75 18.25 51.638 18.25 51.5C18.25 51.362 18.362 51.25 18.5 51.25H39.75C39.888 51.25 40 51.362 40 51.5C40 51.638 39.888 51.75 39.75 51.75Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.5 32H35.625C35.349 32 35.125 31.776 35.125 31.5C35.125 31.224 35.349 31 35.625 31H53.5C53.776 31 54 31.224 54 31.5C54 31.776 53.776 32 53.5 32Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.313 32H25.5C25.224 32 25 31.776 25 31.5C25 31.224 25.224 31 25.5 31H32.313C32.589 31 32.813 31.224 32.813 31.5C32.813 31.776 32.589 32 32.313 32Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.5 37H47.375C47.099 37 46.875 36.776 46.875 36.5C46.875 36.224 47.099 36 47.375 36H53.5C53.776 36 54 36.224 54 36.5C54 36.776 53.776 37 53.5 37Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.125 37H25.5C25.224 37 25 36.776 25 36.5C25 36.224 25.224 36 25.5 36H44.125C44.401 36 44.625 36.224 44.625 36.5C44.625 36.776 44.401 37 44.125 37Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.125 46H25.5C25.224 46 25 45.776 25 45.5C25 45.224 25.224 45 25.5 45H44.125C44.401 45 44.625 45.224 44.625 45.5C44.625 45.776 44.401 46 44.125 46Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.5 42H40.125C39.849 42 39.625 41.776 39.625 41.5C39.625 41.224 39.849 41 40.125 41H53.5C53.776 41 54 41.224 54 41.5C54 41.776 53.776 42 53.5 42Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.813 42H25.5C25.224 42 25 41.776 25 41.5C25 41.224 25.224 41 25.5 41H36.813C37.089 41 37.313 41.224 37.313 41.5C37.313 41.776 37.089 42 36.813 42Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.25 57.5C71.25 57.5 72.817 57.5 74.75 57.5C76.683 57.5 78.25 55.933 78.25 54C78.25 52.219 76.915 50.766 75.195 50.545C75.223 50.366 75.25 50.187 75.25 50C75.25 48.067 73.683 46.5 71.75 46.5C70.718 46.5 69.8 46.955 69.16 47.665C68.776 45.857 67.173 44.5 65.25 44.5C63.041 44.5 61.25 46.291 61.25 48.5C61.25 48.691 61.28 48.874 61.306 49.058C60.878 48.714 60.341 48.5 59.75 48.5C58.522 48.5 57.505 49.387 57.295 50.555C57.116 50.527 56.937 50.5 56.75 50.5C54.817 50.5 53.25 52.067 53.25 54C53.25 55.933 54.817 57.5 56.75 57.5C58.683 57.5 64.25 57.5 64.25 57.5V58H71.25V57.5Z",
			fill: "#FDFCEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73 53C72.862 53 72.75 52.888 72.75 52.75C72.75 51.527 73.745 50.532 74.968 50.532C75.002 50.541 75.705 50.531 76.212 50.668C76.345 50.704 76.424 50.841 76.388 50.974C76.352 51.108 76.215 51.187 76.082 51.15C75.638 51.03 74.982 51.03 74.969 51.032C74.021 51.032 73.25 51.803 73.25 52.75C73.25 52.888 73.138 53 73 53Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.25 58C66.5261 58 66.75 57.7761 66.75 57.5C66.75 57.2239 66.5261 57 66.25 57C65.9739 57 65.75 57.2239 65.75 57.5C65.75 57.7761 65.9739 58 66.25 58Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.75 58H71.25C70.974 58 70.75 57.776 70.75 57.5C70.75 57.224 70.974 57 71.25 57H74.75C76.404 57 77.75 55.654 77.75 54C77.75 52.504 76.625 51.232 75.132 51.041C74.998 51.023 74.877 50.953 74.796 50.845C74.715 50.737 74.681 50.601 74.702 50.468C74.725 50.314 74.75 50.16 74.75 50C74.75 48.346 73.404 47 71.75 47C70.9 47 70.112 47.355 69.531 48C69.406 48.139 69.21 48.198 69.031 48.148C68.849 48.099 68.71 47.953 68.671 47.769C68.33 46.165 66.891 45 65.25 45C63.32 45 61.75 46.57 61.75 48.5C61.75 48.643 61.771 48.78 61.791 48.918C61.82 49.121 61.728 49.356 61.549 49.458C61.37 49.56 61.153 49.576 60.993 49.448C60.628 49.155 60.199 49 59.75 49C58.784 49 57.958 49.691 57.787 50.644C57.739 50.911 57.491 51.09 57.218 51.049C57.064 51.025 56.91 51 56.75 51C55.096 51 53.75 52.346 53.75 54C53.75 55.654 55.096 57 56.75 57H64.25C64.526 57 64.75 57.224 64.75 57.5C64.75 57.776 64.526 58 64.25 58H56.75C54.544 58 52.75 56.206 52.75 54C52.75 51.794 54.544 50 56.75 50C56.809 50 56.866 50.002 56.924 50.006C57.338 48.82 58.461 48 59.75 48C60.099 48 60.439 48.061 60.761 48.18C60.926 45.847 62.876 44 65.25 44C67.081 44 68.716 45.127 69.403 46.774C70.083 46.276 70.905 46 71.75 46C73.956 46 75.75 47.794 75.75 50C75.75 50.048 75.749 50.095 75.746 50.142C77.489 50.59 78.75 52.169 78.75 54C78.75 56.206 76.956 58 74.75 58Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.25 57C69.091 57 68.409 57 68.25 57C67.974 57 67.75 57.224 67.75 57.5C67.75 57.776 67.974 58 68.25 58C68.409 58 69.091 58 69.25 58C69.526 58 69.75 57.776 69.75 57.5C69.75 57.224 69.526 57 69.25 57Z",
			fill: "#1F4C5C"
		})
	]
});
const ForwardRef = forwardRef(SvgCoupons);
export { ForwardRef as ReactComponent };
